import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { EmployeeForm } from "../../components/form/employeeForm";

export const Route = createFileRoute("/employee/new/")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigator = useNavigate();

  const emptyEmployee = {
    firstName: "",
    lastName: "",
    birthDate: "",
  };

  const returnToEmployees = () => {
    navigator({ to: "/employee" });
  };

  const continueToEmployee = (employeeId: number) => {
    navigator({
      to: "/employee/$employeeId",
      params: { employeeId: employeeId.toString() },
    });
  };

  return (
    <div className="flex justify-center items-center mt-10">
      <div className="flex w-3/4 flex-col items-center">
        <h1 className="text-2xl font-bold mb-4">Nieuwe medewerker</h1>
        <EmployeeForm
          employee={emptyEmployee}
          onSave={continueToEmployee}
          onDelete={returnToEmployees}
        />
      </div>
    </div>
  );
}
